/**
 * Paragraph Tasting Grid — Brand Pattern Animation
 *
 * Reuses the hero grid's deboss/emboss aesthetic as a subtle
 * ambient background behind the tasting notes section.
 * No knockout — content floats above on cream card surfaces.
 */

class ParagraphTastingGrid extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.paragraph-tasting');
    if (!this.section) return;

    this.chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    this.cells = [];
    this.rafId = null;
    this.isVisible = false;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.buildGrid();

    if (!this.reducedMotion.matches && !(typeof Shopify !== 'undefined' && Shopify.designMode)) {
      this.observer = new IntersectionObserver(
        function (entries) {
          this.isVisible = entries[0].isIntersecting;
          if (this.isVisible && !this.rafId) this.startAnimation();
          if (!this.isVisible && this.rafId) this.stopAnimation();
        }.bind(this),
        { threshold: 0.05 }
      );
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    this.stopAnimation();
    if (this.observer) this.observer.disconnect();
  }

  buildGrid() {
    var container = document.createElement('div');
    container.className = 'paragraph-grid__cells';

    var rect = this.section.getBoundingClientRect();
    var cellSize = 56;
    var cols = Math.ceil(rect.width / cellSize);
    var rows = Math.ceil(rect.height / cellSize);

    container.style.setProperty('--grid-cols', cols);

    var fragment = document.createDocumentFragment();
    var total = cols * rows;

    for (var i = 0; i < total; i++) {
      var cell = document.createElement('span');

      var style = Math.random();
      if (style < 0.45) {
        cell.className = 'paragraph-grid__cell paragraph-grid__cell--embossed';
      } else if (style < 0.9) {
        cell.className = 'paragraph-grid__cell paragraph-grid__cell--debossed';
      } else {
        cell.className = 'paragraph-grid__cell';
      }

      cell.textContent = this.randomChar();
      fragment.appendChild(cell);
      this.cells.push(cell);
    }

    container.appendChild(fragment);
    this.appendChild(container);
  }

  randomChar() {
    return this.chars[(Math.random() * 26) | 0];
  }

  startAnimation() {
    var self = this;
    var cells = this.cells;
    var len = cells.length;
    var changes = Math.max(1, Math.ceil(len * 0.003));

    function tick() {
      for (var i = 0; i < changes; i++) {
        var idx = (Math.random() * len) | 0;
        cells[idx].textContent = self.randomChar();
      }
      self.rafId = requestAnimationFrame(tick);
    }

    this.rafId = requestAnimationFrame(tick);
  }

  stopAnimation() {
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }
}

customElements.define('paragraph-tasting-grid', ParagraphTastingGrid);
